export function forceDownload(url, fileName) {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = function() {
    var urlCreator = window.URL || window.webkitURL;
    var imageUrl = urlCreator.createObjectURL(this.response);
    var tag = document.createElement("a");
    tag.href = imageUrl;
    tag.download = fileName;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
  xhr.send();
}

const SUPPORTED_MEDIA_EXTENSION = /\.(jpeg|jpg|png|pdf|webp)$/i;

export function mediaDownloadFilename(fileName, mediaSource) {
  const normalizedName = typeof fileName === "string" && fileName ? fileName : "media";
  const sourceWithoutQuery = typeof mediaSource === "string" ? mediaSource.split(/[?#]/)[0] : "";
  const sourceMatch = sourceWithoutQuery.match(SUPPORTED_MEDIA_EXTENSION);
  const nameMatch = normalizedName.match(SUPPORTED_MEDIA_EXTENSION);
  const extension = sourceMatch ? sourceMatch[0].toLowerCase() : nameMatch ? nameMatch[0].toLowerCase() : ".jpg";
  const basename = nameMatch ? normalizedName.slice(0, -nameMatch[0].length) : normalizedName;
  return basename + extension;
}



// WEBPACK FOOTER //
// src/utils/photo.utils.js